import React, { memo, forwardRef } from "react";
const SvgNumbernine = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M16.62 22.52c-.187.28-.373.467-.56.56a1.3 1.3 0 01-1.42-.16c-.227-.213-.34-.493-.34-.84 0-.107.02-.233.06-.38a2.34 2.34 0 01.3-.56l2.46-3.36-.02-.02c-.2.093-.447.16-.74.2-.28.04-.54.06-.78.06a4.548 4.548 0 01-1.76-.34 4.859 4.859 0 01-1.44-.96 4.671 4.671 0 01-.98-1.44 4.751 4.751 0 01-.34-1.8c0-.747.133-1.427.4-2.04a4.666 4.666 0 011.08-1.56 4.682 4.682 0 011.64-1c.64-.24 1.32-.36 2.04-.36.733 0 1.413.127 2.04.38.64.24 1.193.58 1.66 1.02.467.44.827.96 1.08 1.56.267.587.4 1.22.4 1.9 0 .4-.033.78-.1 1.14a5.58 5.58 0 01-.3 1.02c-.12.32-.273.647-.46.98-.173.333-.373.68-.6 1.04l-3.32 4.96zm2.34-9.2c0-.373-.067-.727-.2-1.06-.12-.333-.3-.627-.54-.88a2.496 2.496 0 00-.86-.62 2.556 2.556 0 00-1.12-.24c-.813 0-1.473.267-1.98.8-.493.52-.74 1.2-.74 2.04 0 .4.06.773.18 1.12.133.333.32.62.56.86.24.24.52.433.84.58.333.133.7.2 1.1.2.4 0 .767-.067 1.1-.2.347-.133.64-.32.88-.56.253-.253.447-.553.58-.9.133-.347.2-.727.2-1.14z"
      />
    </svg>
  );
});
SvgNumbernine.displayName = "SvgNumbernine";
const MemoForwardRef = memo(SvgNumbernine);
export default MemoForwardRef;
